import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { BookOpen, Target, Bell, ClipboardCheck, ArrowRight } from "lucide-react";
import { EXISTING_USER_CARDS } from "../data/content";

const ICONS = { BookOpen, Target, Bell, ClipboardCheck };

export const ExistingUserSection = () => {
  return (
    <section className="relative overflow-hidden bg-brand-deep py-20 sm:py-28" data-testid="existing-user-section">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-20 right-0 h-80 w-80 rounded-full bg-brand/40 blur-3xl" />
        <div className="absolute bottom-0 -left-20 h-72 w-72 rounded-full bg-brand-green/20 blur-3xl" />
      </div>

      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl">
          <span className="text-sm font-bold uppercase tracking-[0.2em] text-brand-light">Hai già la tua PushApp?</span>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl font-bold tracking-tight text-white">
            Il centro guida per usarla al meglio
          </h2>
          <p className="mt-4 font-body text-base sm:text-lg text-white/75 leading-relaxed">
            Approfondimenti pensati per chi è già a bordo: impara a creare contenuti, scopri
            quali notifiche inviare e costruisci una strategia che funziona ogni mese.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {EXISTING_USER_CARDS.map((c, i) => {
            const Icon = ICONS[c.icon];
            return (
              <motion.div
                key={c.to}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.45, delay: i * 0.08 }}
              >
                <Link
                  to={c.to}
                  data-testid={`existing-card-${c.to.replace("/", "")}`}
                  className="group flex h-full flex-col rounded-3xl bg-white/5 backdrop-blur border border-white/10 p-6 transition-all duration-300 hover:bg-white/10 hover:-translate-y-1.5"
                >
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-white/10 text-brand-light transition-colors group-hover:bg-brand group-hover:text-white">
                    <Icon size={24} strokeWidth={2.5} />
                  </span>
                  <h3 className="mt-5 font-heading text-lg font-semibold text-white">{c.title}</h3>
                  <p className="mt-2 font-body text-sm text-white/70 leading-relaxed flex-1">{c.text}</p>
                  <span className="mt-4 inline-flex items-center gap-1.5 font-body text-sm font-semibold text-brand-light group-hover:gap-2.5 transition-all">
                    Scopri <ArrowRight size={15} strokeWidth={2.5} />
                  </span>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
